import VMenu from '../menu/v-menu.vue';

export default VMenu;